export default __webpack_public_path__ + "static/media/codeBar.0a57433a.svg";